export const buildFormFieldPayload = ({
  values,
  fieldType,
  defValue,
  selectedField,
}) => {
  const payload = {
    ...values,
    field_type: fieldType,
    parent_field_id:
      fieldType === "option" ? values?.parent_field_id?.value || "" : null,
    def_value: defValue,
    ...(selectedField ? { field_id: selectedField.field_id } : {}),
  };

  delete payload.use_default_value;

  if (fieldType === "option") {
    delete payload.def_value;
  }

  return payload;
};
